import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULT_DESCRIPTION =
  "FunAsia Digital — The advertising platform that drives real customers to your business. SmartReach™ combines digital, radio, hyperlocal targeting, and loyalty rewards.";
const DEFAULT_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_1b7e3ff3-a6f2-4f8b-ba70-0b0056d06e3d/artifacts/arydq0cs_funasi%20digital.png";

/**
 * SEO component — wraps react-helmet-async for per-route meta tags.
 * Usage: <SEO title="..." description="..." path="/route" />
 */
export const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "",
  image = DEFAULT_OG_IMAGE,
  noIndex = false,
  children
}) => {
  const fullTitle = title
    ? `${title} | FunAsia Digital`
    : "FunAsia Digital — Drive Real Customers With SmartReach™";
  const url = `https://funasiadigital.com${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="FunAsia Digital" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Optional structured data (JSON-LD) */}
      {children}
    </Helmet>
  );
};

export default SEO;
